export default __webpack_public_path__ + "static/media/landscape4.70e245fa.jpeg";